module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAmCAYAAACf8yaaAAAAqElEQVRoQ+3XUQrDIBCEYT1cT53DtQTyUEJgtEio8fN5MDqZf9etpZR3mXPV0cfeN2TG4SozvuLFDGZcV5vhRWh0UbtzP2acMLnT/L/+lmRIhgIaEYUJTGACk+gATGASQzLz1Bov1ytgxkNG+N4fH/WSIRm6SRMmUbSKwKDmBapmRNphAhOYwCQ6ABOYxJDs3WSLqrkFr9bjrzC1Nj8fmLHYCC8Zv3TMDxtVDyJEfCEpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/menu.png
// module id = Hosi
// module chunks = 11